import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/apps/nuxt/app/layouts/default.vue").then(m => m.default || m)),
  manage: defineAsyncComponent(() => import("/app/apps/nuxt/app/layouts/manage.vue").then(m => m.default || m)),
  pledge: defineAsyncComponent(() => import("/app/apps/nuxt/app/layouts/pledge.vue").then(m => m.default || m))
}